// extracted by mini-css-extract-plugin
module.exports = {"zone":"DropTarget_zone__29Fml","Draggable":"DropTarget_Draggable__2E_mU","drag-content":"DropTarget_drag-content__sgjHw","time":"DropTarget_time__qw7w6"};